module.exports = __webpack_public_path__ + "img/digital.1bcf726c.png";